/**
 * VirusTypes - Kanonische Liste der Virus-Typen (Single Source of Truth).
 *
 * Isomorph (Browser + Node, keine Imports). Server-Validierung (GameManager,
 * LobbyHandlers), Client-Picker, Renderer-Zuordnung und die GameCore-Spiegelliste
 * leiten sich alle hieraus ab, damit die Listen nie wieder auseinanderdriften
 * (vgl. SphereGeometry.js). Bewusst nur IDs — Anzeigenamen kommen aus i18n
 * (lobby.virusTypes.<id>), Render-Eigenschaften aus VirusRenderer.VIRUS_TYPES.
 *
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

/** @type {ReadonlyArray<string>} Kanonische Virus-Typ-IDs in Picker-Reihenfolge */
export const VIRUS_TYPE_IDS = Object.freeze(['classic', 'spiky', 'blob', 'crystal', 'toxic', 'digital']);

/** Fallback, wenn ein Typ fehlt oder ungültig ist */
export const DEFAULT_VIRUS_TYPE = 'classic';

/**
 * Prüft, ob eine ID ein gültiger Virus-Typ ist.
 * @param {unknown} id
 * @returns {boolean}
 */
export function isValidVirusType(id) {
    return typeof id === 'string' && VIRUS_TYPE_IDS.includes(id);
}

/**
 * Liefert die ID zurück, wenn gültig, sonst den Default.
 * @param {unknown} id
 * @returns {string}
 */
export function normalizeVirusType(id) {
    return isValidVirusType(id) ? id : DEFAULT_VIRUS_TYPE;
}
